import {TTaxForecastCore} from 'pages/ais/submit-income-tax-forecast/model/types';

interface ITaxForecastEditModalFields {
    sectionTitle: string;
    forecastKeyFts: keyof TTaxForecastCore;
    commentKeyFts: keyof TTaxForecastCore;
    forecastKeyOrg: keyof TTaxForecastCore;
    commentKeyOrg: keyof TTaxForecastCore;
}
export const CREATE_COMMENT_FORM_FIELDS: ITaxForecastEditModalFields[] = [
    {
        sectionTitle: 'Прогнозное значение по налогу на прибыль',
        forecastKeyFts: 'taxbaseForecastFts',
        commentKeyFts: 'taxbaseCommentFts',
        forecastKeyOrg: 'taxbaseForecastOrg',
        commentKeyOrg: 'taxbaseCommentOrg',
    },
    {
        sectionTitle: 'Прогноз суммы налога на прибыль в федеральный бюджет РФ',
        forecastKeyFts: 'federalTaxForecastFts',
        commentKeyFts: 'federalTaxCommentFts',
        forecastKeyOrg: 'federalTaxForecastOrg',
        commentKeyOrg: 'federalTaxCommentOrg',
    },
    {
        sectionTitle: 'Прогноз суммы налога на прибыль в бюджет субъекта РФ',
        forecastKeyFts: 'regionalTaxForecastFts',
        commentKeyFts: 'regionalTaxCommentFts',
        forecastKeyOrg: 'regionalTaxForecastOrg',
        commentKeyOrg: 'regionalTaxCommentOrg',
    },
];
